import SetupData from '@/router/SetupData';
import {
  getStaleFlag,
  triggerVersionCheck,
  handleStalenessOrReload,
} from '@/utils/versionState';
import { initFeatureFlags, getFlag } from '@/utils/featureFlags';
import { FEATURE_FLAGS } from '@/config/featureFlags';

const guardRouter = (router) => {
  router.beforeEach(async (to, from, next) => {
    // Si ya sabemos que la app está desactualizada, recargar inmediatamente
    if (getStaleFlag()) {
      handleStalenessOrReload();
      return; // No llamamos next() porque vamos a recargar
    }

    // Disparar verificación de versión en cada navegación (fire-and-forget)
    triggerVersionCheck();

    // En mantenimiento App.vue muestra la pantalla de mantenimiento en lugar del
    // router-view, así que se deja pasar la navegación sin hidratar datos de SAP
    await initFeatureFlags();
    if (getFlag(FEATURE_FLAGS.MAINTENANCE_MODE.key)) {
      next();
      return;
    }

    const tokenExists = localStorage.token && localStorage.refresh;

    if (to.meta.requiresAuth) {
      if (tokenExists) {
        await SetupData();
        next();
      } else {
        next('/auth/login/');
      }
    } else if (to.meta.isAuthPage) {
      if (tokenExists) {
        next('/');
      } else {
        next();
      }
    } else {
      next();
    }
  });

  // Capturar errores de carga de chunks en navegación
  router.onError((error) => {
    const isChunkError = error?.message?.includes('Failed to fetch dynamically imported module')
      || error?.message?.includes('Loading chunk')
      || error?.message?.includes('Loading CSS chunk')
      || error?.name === 'ChunkLoadError';

    if (isChunkError) {
      console.warn('Chunk load error detected in router, triggering reload');
      handleStalenessOrReload();
    }
  });
};

export default guardRouter;
